import { Badge as e } from "../badge/index.js";
import { Icon as t } from "../icon/index.js";
import { cn as n } from "../cn.js";
import { filterActionButton as r, filterClearButton as i, filterClearSpacer as a, filterClearTrigger as o, filterContent as ee, filterControl as te, filterIndicator as ne, filterItem as re, filterItemGroup as ie, filterItemIndicator as s, filterItemText as c, filterLabel as l, filterPositioner as u, filterRoot as d, filterSearchIconWrapper as f, filterSearchInput as ae, filterSearchWrapper as oe, filterTrigger as p, filterTriggerIcon as se, filterTriggerWrap as ce, filterValueText as le, searchClearTrigger as m } from "./style.js";
import h, { forwardRef as g, useMemo as _, useState as v } from "react";
import { Check as y, ChevronDown as b, Search as x, X as S } from "lucide-react";
import { Fragment as C, jsx as w, jsxs as T } from "react/jsx-runtime";
import { Portal as E } from "@ark-ui/react/portal";
import { When as D } from "react-if";
import { Combobox as O, createListCollection as ue } from "@ark-ui/react/combobox";
import { useFilter as k } from "@ark-ui/react";
// src/design/filter/index.tsx
var de = (e) => e.map((e) => typeof e == "string" ? {
	label: e,
	value: e
} : e), A = (e, t) => {
	let n = t.toLowerCase();
	return n ? e.filter((e) => e.label.toLowerCase().includes(n)) : e;
}, j = g(({ items: e, value: g, onValueChange: k, label: j, labelPosition: M = "top", placeholder: N = "Select...", size: P = "sm", searchable: F = !0, clearable: I = !0, icon: L, disabled: R = !1, className: z, open: B, onOpenChange: V, renderItem: H, loading: U = !1, loadingText: fe = "Loading...", emptyText: pe = "No items found", onActionClick: W, actionIcon: me }, he) => {
	let [G, K] = v(""), q = h.useRef(null), J = _(() => de(e), [e]), Y = _(() => A(J, G), [J, G]), X = _(() => ue({
		items: Y,
		itemToValue: (e) => String(e.value),
		itemToString: (e) => e.label,
		isItemDisabled: (e) => !!e.disabled
	}), [Y]), Z = (e) => {
		K(e.inputValue);
	}, ge = (e) => {
		let t = e.value[0], n = t ? J.find((e) => String(e.value) === t) : null;
		k?.(n || null), setTimeout(() => {
			K(""), q.current?.focus();
		}, 0);
	}, _e = (e) => {
		e?.stopPropagation(), k?.(null), K("");
	}, ve = g?.label || "", Q = !!g, ye = I && !!g;
	return /* @__PURE__ */ w("div", {
		ref: he,
		className: n(d(), z),
		children: /* @__PURE__ */ T(O.Root, {
			collection: X,
			value: g ? [String(g.value)] : [],
			onValueChange: ge,
			inputValue: G,
			onInputValueChange: Z,
			disabled: R,
			inputBehavior: "none",
			selectionBehavior: "clear",
			open: B,
			onOpenChange: V,
			children: [/* @__PURE__ */ T(O.Control, {
				className: te({ labelPosition: M }),
				children: [/* @__PURE__ */ w(D, {
					condition: !!j,
					children: /* @__PURE__ */ w(O.Label, {
						className: l(),
						children: j
					})
				}), /* @__PURE__ */ T("span", {
					className: ce(),
					children: [/* @__PURE__ */ T(O.Trigger, {
						className: p({
							size: P,
							selected: Q
						}),
						tabIndex: 0,
						"aria-label": [j, ve || N].filter(Boolean).join(": "),
						children: [
							/* @__PURE__ */ w("span", {
								className: se({ selected: Q }),
								children: L ?? /* @__PURE__ */ w(t, { name: "Diamond" })
							}),
							/* @__PURE__ */ w("span", {
								className: le({ selected: Q }),
								children: ve || N
							}),
							/* @__PURE__ */ w("span", {
								className: "relative flex items-center justify-center",
								children: ye ? /* @__PURE__ */ w("span", {
									"aria-hidden": "true",
									className: a()
								}) : /* @__PURE__ */ w("span", {
									className: ne({ selected: Q }),
									children: /* @__PURE__ */ w(b, { className: "h-4 w-4" })
								})
							})
						]
					}), /* @__PURE__ */ w(D, {
						condition: ye,
						children: /* @__PURE__ */ w("button", {
							type: "button",
							onClick: _e,
							"aria-label": j ? `Clear ${j}` : "Clear filter",
							className: o(),
							children: /* @__PURE__ */ w(S, { className: "h-4 w-4" })
						})
					})]
				})]
			}), /* @__PURE__ */ w(E, { children: /* @__PURE__ */ w(O.Positioner, {
				className: u(),
				children: /* @__PURE__ */ T(O.Content, {
					className: ee(),
					children: [
						/* @__PURE__ */ w(D, {
							condition: F || !!W,
							children: /* @__PURE__ */ T("div", {
								className: oe(),
								children: [/* @__PURE__ */ w(D, {
									condition: F,
									children: /* @__PURE__ */ T("div", {
										className: "relative flex-1 min-w-0",
										children: [
											/* @__PURE__ */ w("span", {
												className: f(),
												children: /* @__PURE__ */ w(x, { className: "h-4 w-4" })
											}),
											/* @__PURE__ */ w(O.Input, {
												ref: q,
												className: ae(),
												placeholder: "Search..."
											}),
											/* @__PURE__ */ w(D, {
												condition: G.length > 0,
												children: /* @__PURE__ */ w("button", {
													type: "button",
													onClick: (e) => {
														e.stopPropagation(), K("");
													},
													"aria-label": "Clear search",
													className: m(),
													children: /* @__PURE__ */ w(S, { className: "h-4 w-4" })
												})
											})
										]
									})
								}), /* @__PURE__ */ w(D, {
									condition: !!W,
									children: /* @__PURE__ */ w("button", {
										type: "button",
										onClick: W,
										className: r(),
										"aria-label": "Action",
										children: me || /* @__PURE__ */ w(S, { className: "h-4 w-4" })
									})
								})]
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: U,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: fe
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: !U && Y.length === 0,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: pe
							})
						}),
						/* @__PURE__ */ T(D, {
							condition: !U && Y.length > 0,
							children: [/* @__PURE__ */ w(O.ItemGroup, {
								className: ie(),
								children: Y.map((e) => /* @__PURE__ */ w(O.Item, {
									item: e,
									className: re(),
									children: H ? /* @__PURE__ */ w(C, { children: H(e) }) : /* @__PURE__ */ T(C, { children: [
										/* @__PURE__ */ w(D, {
											condition: g?.value === e.value,
											children: /* @__PURE__ */ w(O.ItemIndicator, {
												className: s(),
												children: /* @__PURE__ */ w(y, { className: "h-4 w-4" })
											})
										}),
										/* @__PURE__ */ w(D, {
											condition: g?.value !== e.value,
											children: /* @__PURE__ */ w("span", { className: "flex h-4 w-4 shrink-0 mr-2" })
										}),
										/* @__PURE__ */ w(O.ItemText, {
											className: c(),
											children: e.label
										})
									] })
								}, String(e.value)))
							}), /* @__PURE__ */ w(D, {
								condition: I && !!g,
								children: /* @__PURE__ */ w("div", {
									className: "px-2 py-1.5 border-t border-border",
									children: /* @__PURE__ */ w("button", {
										type: "button",
										onClick: _e,
										className: i(),
										children: "Clear selection"
									})
								})
							})]
						})
					]
				})
			}) })]
		})
	});
});
j.displayName = "Filter.SingleSelect";
var M = g(({ items: t, value: g = [], onValueChange: k, label: j, labelPosition: M = "top", placeholder: N = "Select...", size: P = "sm", searchable: F = !0, clearable: I = !0, icon: L, disabled: R = !1, className: z, open: B, onOpenChange: V, renderItem: H, loading: U = !1, loadingText: fe = "Loading...", emptyText: pe = "No items found", onActionClick: W, actionIcon: me, getSelectedLabel: he, hideSelectedValues: G = !1 }, K) => {
	let [q, J] = v(""), Y = h.useRef(null), X = _(() => de(t), [t]), Z = _(() => A(X, q), [X, q]), ge = _(() => ue({
		items: Z,
		itemToValue: (e) => String(e.value),
		itemToString: (e) => e.label,
		isItemDisabled: (e) => !!e.disabled
	}), [Z]), _e = (e) => {
		J(e.inputValue);
	}, ve = (e) => {
		let t = e.value.map((e) => X.find((t) => String(t.value) === e)).filter((e) => e !== void 0);
		k?.(t), setTimeout(() => {
			Y.current?.focus();
		}, 0);
	}, Q = (e) => {
		e?.stopPropagation(), k?.([]), J("");
	}, ye = (e) => {
		k?.(g.filter((t) => t.value !== e.value));
	}, be = g.length > 0 ? he?.(g) ?? `${g.length} selected` : N, $ = g.length > 0, xe = I && g.length > 0;
	return /* @__PURE__ */ w("div", {
		ref: K,
		className: n(d(), z),
		children: /* @__PURE__ */ T(O.Root, {
			collection: ge,
			value: g.map((e) => String(e.value)),
			onValueChange: ve,
			inputValue: q,
			onInputValueChange: _e,
			multiple: !0,
			disabled: R,
			inputBehavior: "none",
			selectionBehavior: "clear",
			open: B,
			onOpenChange: V,
			children: [/* @__PURE__ */ T(O.Control, {
				className: te({ labelPosition: M }),
				children: [/* @__PURE__ */ w(D, {
					condition: !!j,
					children: /* @__PURE__ */ w(O.Label, {
						className: l(),
						children: j
					})
				}), /* @__PURE__ */ T("span", {
					className: ce(),
					children: [/* @__PURE__ */ T(O.Trigger, {
						className: p({
							size: P,
							selected: $
						}),
						tabIndex: 0,
						"aria-label": [j, be || N].filter(Boolean).join(": "),
						children: [
							/* @__PURE__ */ w(D, {
								condition: !!L,
								children: /* @__PURE__ */ w("span", {
									className: se({ selected: $ }),
									children: L
								})
							}),
							/* @__PURE__ */ w("span", {
								className: le({ selected: $ }),
								children: be
							}),
							/* @__PURE__ */ w("span", {
								className: "relative flex items-center justify-center",
								children: xe ? /* @__PURE__ */ w("span", {
									"aria-hidden": "true",
									className: a()
								}) : /* @__PURE__ */ w("span", {
									className: ne({ selected: $ }),
									children: /* @__PURE__ */ w(b, { className: "h-4 w-4" })
								})
							})
						]
					}), /* @__PURE__ */ w(D, {
						condition: xe,
						children: /* @__PURE__ */ w("button", {
							type: "button",
							onClick: Q,
							"aria-label": j ? `Clear ${j}` : "Clear filter",
							className: o(),
							children: /* @__PURE__ */ w(S, { className: "h-4 w-4" })
						})
					})]
				})]
			}), /* @__PURE__ */ w(E, { children: /* @__PURE__ */ w(O.Positioner, {
				className: u(),
				children: /* @__PURE__ */ T(O.Content, {
					className: ee(),
					children: [
						/* @__PURE__ */ w(D, {
							condition: F || !!W,
							children: /* @__PURE__ */ T("div", {
								className: oe(),
								children: [/* @__PURE__ */ w(D, {
									condition: F,
									children: /* @__PURE__ */ T("div", {
										className: "relative flex-1 min-w-0",
										children: [
											/* @__PURE__ */ w("span", {
												className: f(),
												children: /* @__PURE__ */ w(x, { className: "h-4 w-4" })
											}),
											/* @__PURE__ */ w(O.Input, {
												ref: Y,
												className: ae(),
												placeholder: "Search..."
											}),
											/* @__PURE__ */ w(D, {
												condition: q.length > 0,
												children: /* @__PURE__ */ w("button", {
													type: "button",
													onClick: (e) => {
														e.stopPropagation(), J("");
													},
													"aria-label": "Clear search",
													className: m(),
													children: /* @__PURE__ */ w(S, { className: "h-4 w-4" })
												})
											})
										]
									})
								}), /* @__PURE__ */ w(D, {
									condition: !!W,
									children: /* @__PURE__ */ w("button", {
										type: "button",
										onClick: W,
										className: r(),
										"aria-label": "Action",
										children: me || /* @__PURE__ */ w(S, { className: "h-4 w-4" })
									})
								})]
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: !G && g.length > 0,
							children: /* @__PURE__ */ w("div", {
								className: "flex flex-wrap gap-1 p-2 border-b border-border",
								children: g.map((t) => /* @__PURE__ */ w(e, {
									variant: "soft",
									size: "sm",
									className: "gap-1",
									removable: !0,
									onRemove: () => {
										ye(t);
									},
									children: t.label
								}, String(t.value)))
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: U,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: fe
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: !U && Z.length === 0,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: pe
							})
						}),
						/* @__PURE__ */ T(D, {
							condition: !U && Z.length > 0,
							children: [/* @__PURE__ */ w(O.ItemGroup, {
								className: ie(),
								children: Z.map((e) => /* @__PURE__ */ w(O.Item, {
									item: e,
									className: re(),
									children: H ? /* @__PURE__ */ w(C, { children: H(e) }) : /* @__PURE__ */ T(C, { children: [
										/* @__PURE__ */ w(O.ItemIndicator, {
											className: s(),
											children: /* @__PURE__ */ w(y, { className: "h-4 w-4" })
										}),
										/* @__PURE__ */ w(D, {
											condition: !g.some((t) => t.value === e.value),
											children: /* @__PURE__ */ w("span", { className: "flex h-4 w-4 shrink-0 mr-2" })
										}),
										/* @__PURE__ */ w(O.ItemText, {
											className: c(),
											children: e.label
										})
									] })
								}, String(e.value)))
							}), /* @__PURE__ */ w(D, {
								condition: I && g.length > 0,
								children: /* @__PURE__ */ w("div", {
									className: "px-2 py-1.5 border-t border-border",
									children: /* @__PURE__ */ w("button", {
										type: "button",
										onClick: Q,
										className: i(),
										children: "Clear all"
									})
								})
							})]
						})
					]
				})
			}) })]
		})
	});
});
M.displayName = "Filter.MultiSelect";
var N = g(({ items: e, value: t, onValueChange: r, placeholder: i = "Select...", multiple: a = !1, searchable: o = !0, icon: l, disabled: f = !1, className: ae, open: oe, onOpenChange: ce, onActionClick: m, actionIcon: h, loading: g = !1, loadingText: C = "Loading...", emptyText: k = "No items found" }, j) => {
	let [M, N] = v(""), P = _(() => de(e), [e]), F = _(() => A(P, M), [P, M]), I = Array.isArray(t) ? t : t ? [t] : [], L = _(() => ue({ items: F.map((e) => String(e.value)) }), [F]), R = (e) => {
		N(e.inputValue);
	}, z = (e) => {
		if (a) {
			let t = e.value.map((e) => P.find((t) => String(t.value) === e)).filter((e) => e !== void 0);
			r?.(t);
		} else {
			let t = e.value[0], n = t ? P.find((e) => String(e.value) === t) : null;
			r?.(n || null);
		}
		N("");
	}, B = _(() => I.length === 0 ? i : a ? `${I.length} selected` : I[0]?.label || i, [
		I,
		i,
		a
	]), V = I.length > 0;
	return /* @__PURE__ */ w("div", {
		ref: j,
		className: n(d(), ae),
		children: /* @__PURE__ */ T(O.Root, {
			collection: L,
			value: I.map((e) => String(e.value)),
			onValueChange: z,
			onInputValueChange: R,
			multiple: a,
			disabled: f,
			inputBehavior: "none",
			selectionBehavior: "clear",
			open: oe,
			onOpenChange: ce,
			children: [/* @__PURE__ */ w(O.Control, {
				className: te(),
				children: /* @__PURE__ */ T(O.Trigger, {
					className: p({
						size: "sm",
						selected: V
					}),
					tabIndex: 0,
					"aria-label": B || i,
					children: [
						/* @__PURE__ */ w(D, {
							condition: !!l,
							children: /* @__PURE__ */ w("span", {
								className: se({ selected: V }),
								children: l
							})
						}),
						/* @__PURE__ */ w("span", {
							className: le({ selected: V }),
							children: B
						}),
						/* @__PURE__ */ w("span", {
							className: ne({ selected: V }),
							children: /* @__PURE__ */ w(b, { className: "h-4 w-4" })
						})
					]
				})
			}), /* @__PURE__ */ w(E, { children: /* @__PURE__ */ w(O.Positioner, {
				className: u(),
				children: /* @__PURE__ */ T(O.Content, {
					className: ee(),
					children: [
						/* @__PURE__ */ w(D, {
							condition: o || !!m,
							children: /* @__PURE__ */ T("div", {
								className: "flex items-center gap-2 px-2 py-2 border-b border-border",
								children: [/* @__PURE__ */ w(D, {
									condition: o,
									children: /* @__PURE__ */ T("div", {
										className: "relative flex-1 min-w-0",
										children: [
											/* @__PURE__ */ w("span", {
												className: "absolute left-2 top-1/2 -translate-y-1/2 flex h-4 w-4 items-center justify-center text-muted-foreground",
												children: /* @__PURE__ */ w(x, { className: "h-4 w-4" })
											}),
											/* @__PURE__ */ w(O.Input, {
												className: "h-9 w-full rounded-md border border-border bg-white px-3 pl-8 pr-8 text-sm text-foreground placeholder:text-muted-foreground dark:dark:transition-all focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-hidden",
												placeholder: "search"
											}),
											/* @__PURE__ */ w(D, {
												condition: M.length > 0,
												children: /* @__PURE__ */ w("button", {
													type: "button",
													onClick: (e) => {
														e.stopPropagation(), N("");
													},
													className: "absolute right-2 top-1/2 -translate-y-1/2 flex h-4 w-4 items-center justify-center text-muted-foreground hover:text-muted-foreground transition-colors",
													children: /* @__PURE__ */ w(S, { className: "h-4 w-4" })
												})
											})
										]
									})
								}), /* @__PURE__ */ w(D, {
									condition: !!m,
									children: /* @__PURE__ */ w("button", {
										type: "button",
										onClick: m,
										className: "flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-border bg-white text-muted-foreground transition-colors hover:bg-muted hover:text-muted-foreground",
										"aria-label": "Action",
										children: h || /* @__PURE__ */ w(S, { className: "h-4 w-4" })
									})
								})]
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: g,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: C
							})
						}),
						/* @__PURE__ */ w(D, {
							condition: !g && F.length === 0,
							children: /* @__PURE__ */ w("div", {
								className: "px-4 py-8 text-center text-sm text-muted-foreground",
								children: k
							})
						}),
						/* @__PURE__ */ T(D, {
							condition: !g && F.length > 0,
							children: [/* @__PURE__ */ w(O.ItemGroup, {
								className: ie(),
								children: F.map((e) => /* @__PURE__ */ T(O.Item, {
									item: String(e.value),
									className: re(),
									children: [
										/* @__PURE__ */ w(O.ItemIndicator, {
											className: s(),
											children: /* @__PURE__ */ w(y, { className: "h-4 w-4" })
										}),
										/* @__PURE__ */ w(D, {
											condition: !I.some((t) => t.value === e.value),
											children: /* @__PURE__ */ w("span", { className: "flex h-4 w-4 shrink-0 mr-2" })
										}),
										/* @__PURE__ */ w(O.ItemText, {
											className: c(),
											children: e.label
										})
									]
								}, String(e.value)))
							}), /* @__PURE__ */ w(D, {
								condition: I.length > 0,
								children: /* @__PURE__ */ w("div", {
									className: "px-2 py-1.5 border-t border-border",
									children: /* @__PURE__ */ T("button", {
										type: "button",
										onClick: (e) => {
											e.stopPropagation(), a ? r?.([]) : r?.(null);
										},
										className: "w-full text-left px-2 py-1.5 text-sm text-destructive-text hover:bg-destructive/5 rounded-sm transition-colors",
										children: ["Clear ", a ? "all" : "selection"]
									})
								})
							})]
						})
					]
				})
			}) })]
		})
	});
});
N.displayName = "Filter.Hidden";
var P = Object.assign(() => null, {
	Root: O.Root,
	Control: O.Control,
	Label: O.Label,
	Trigger: O.Trigger,
	Input: O.Input,
	ClearTrigger: O.ClearTrigger,
	Portal: E,
	Positioner: O.Positioner,
	Content: O.Content,
	ItemGroup: O.ItemGroup,
	Item: O.Item,
	ItemText: O.ItemText,
	ItemIndicator: O.ItemIndicator,
	SingleSelect: j,
	MultiSelect: M,
	Hidden: N
}), F = j, I = M, L = N;
export { P as Filter, P as default, L as FilterHidden, I as FilterMultiSelect, F as FilterSingleSelect, k as useFilter };

//# sourceMappingURL=index.js.map